module.exports = __webpack_public_path__ + "media/images/icon__questionmark--rb-light-gray@2x-e7b696d743a342d67a4a4450812dbde7.png";